import { render } from "./CheckRadioPicker.vue?vue&type=template&id=220168e3"
import script from "./CheckRadioPicker.vue?vue&type=script&lang=js"
export * from "./CheckRadioPicker.vue?vue&type=script&lang=js"

import "./CheckRadioPicker.vue?vue&type=style&index=0&id=220168e3&lang=css"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__